import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MessageMain } from '../../app-bookings-messages/message-main';

class MessageMainContainer extends Component {
  componentWillReceiveProps (nextProps) {
    const { profile } = nextProps;

    // if user logs out, redirect to sign in
    if (!profile.SSOid) {
      location.href = '/';
    }
  }

  componentDidMount () {
    if (window.dataLayer) {
      window.dataLayer.push({ event: 'optimize.activate.loaded' });
    }
  }

  render () {
    const { isFetching } = this.props;

    return (
      <div>
        { isFetching
          ? null
          : <MessageMain {...this.props} />
        }
      </div>
    );
  }
}

MessageMainContainer.propTypes = {//TODO: do we put it here?
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired
};

function mapStateToProps (state) {
  const { auth, profile, nav, booking, services, env } = state;

  const {
    isFetching
  } = profile || {
    isFetching: true
  };

  return {
    auth,
    profile,
    isFetching,
    nav,
    booking,
    services,
    env
  };
}

export default connect(mapStateToProps)(MessageMainContainer);
